import { render, staticRenderFns } from "./CustomSection04.vue?vue&type=template&id=f197690a&scoped=true&"
import script from "./CustomSection04.vue?vue&type=script&lang=js&"
export * from "./CustomSection04.vue?vue&type=script&lang=js&"
import style0 from "./CustomSection04.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CustomSection04.vue?vue&type=style&index=1&id=f197690a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f197690a",
  null
  
)

component.options.__file = "CustomSection04.vue"
export default component.exports